






























import { Component, Vue, Watch } from 'vue-property-decorator';
import dayjs from "dayjs";
import { TbSupplier } from '@/http';
@Component({
    components: {
      
    },
})
export default class supplierPanel extends Vue {
    public $refs: {
    };
    columnsUnit= [];
    
    show = false;

    defaultIndex = 0;

    created() {
    }
    mounted() {
     
        
    }

    moveHandle() {}
    onClose(){
        this.show = false;
    }
    Confirm(value){
        this.$emit("supplierConfirm",value);
        this.show = false;
    }
   
    async showFun(val){
        await this.init();
        if(val){
            this.defaultIndex  = this.columnsUnit.findIndex(v=>v.id==val);
        }
        this.show = true;
    }

    async init(){
        let res = await TbSupplier.GetTbSupplierDropList();
        this.columnsUnit = res;
    }
    
   
}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/components/pad/supplierPanel.vue